import { createFileRoute } from '@tanstack/react-router'
import ContactNotes from 'Contact/components/Contact/Sections/ContactNotes'

export const Route = createFileRoute('/contact/$contactId/notes')({
    component: ContactNotes,
})
